export const MODE_CAMERA = 'camera';
export const MODE_LIVE = 'live';
export const EDEVICETYPE = {
  CAMERA: 'camera',
  GATEWAY: 'gateway',
  GPS: 'gps_location',
  SPEAKER: 'speaker_sip',
};

export const REPORT_TYPE = {
  REPORT_ACCOUNT: 'report_account',
  REPORT_STORAGE: 'report_storage',
  REPORT_GATEWAY: 'report_gateway',
  REPORT_GATEWAY_INFO: 'report_gateway_info',
};
